const initShare = () => {
  if (typeof FB === "undefined") {
    const meta = document.querySelector("meta[name=fb_id]");
    const appId = meta ? meta.getAttribute("content") : null;

    if (appId) {
      window.fbAsyncInit = function () {
        FB.init({
          appId: appId,
          status: true,
          cookie: true,
          xfbml: true,
          version: "v2.2",
        });
        FB.Canvas.setAutoGrow(91);
        FB.Canvas.scrollTo(0, 0);
      };

      (function (d, s, id) {
        let js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }
  }

  $(".share .share-button").click(function () {
    $(this).closest(".share").toggleClass("share_is_active");
  });

  $("#facebook-share").click(function () {
    if (typeof FB !== "undefined") {
      FB.ui(
        {
          method: "share",
          href: window.location.href,
        },
        function (response) {}
      );
    }
  });

  $(".share .share-link .share-outbound a").click(function (e) {
    e.preventDefault();

    const width = 640;
    const height = 480;
    const screenWidth = $(window).width();
    const screenHeight = $(window).height();
    const left = Math.round((screenWidth - width) / 2);
    const top = Math.round((screenHeight - height) / 2);

    const windowName = `window_name_${new Date().getTime()}`;
    const windowFeatures = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, width=${width}, height=${height}, left=${left}, top=${top}`;

    window.open($(this).attr("href"), windowName, windowFeatures);

    return false;
  });
};

document.addEventListener("DOMContentLoaded", initShare);
document.addEventListener("turbolinks:load", initShare);

$(document).on("share-button:ready", initShare);

export default initShare;
